function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1178",
  "data-name": "Grupo 1178",
  transform: "translate(-440.693 -80.979)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_676",
  "data-name": "Grupo 676",
  transform: "translate(445.486 93.766)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_927",
  "data-name": "Caminho 927",
  d: "M466.45,106.93h-7.961l-.032-9.25h-7.063l-.145,9.25h-8.031V87.717h1.423v17.79h5.206l.145-9.25h9.882l.032,9.25h5.12V87.717h1.423Z",
  transform: "translate(-443.219 -87.717)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_677",
  "data-name": "Grupo 677",
  transform: "translate(468.005 90.46)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_928",
  "data-name": "Caminho 928",
  d: "M455.084,85.975",
  transform: "translate(-455.084 -85.975)",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_678",
  "data-name": "Grupo 678",
  transform: "translate(440.693 80.979)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_929",
  "data-name": "Caminho 929",
  d: "M472.6,95.582,457.1,82.824,441.6,95.582l-.9-1.1,16.4-13.5,16.4,13.5Z",
  transform: "translate(-440.693 -80.979)"
})));

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.807,
    height: 32,
    viewBox: "0 0 32.807 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9e7cc04f.svg";
export { ForwardRef as ReactComponent };